<div class="welcome">
  <div class="welcome__container">
    <div class="welcome__container__logo">
      <img src="assets/images/logo.svg" />
    </div>

    <div class="welcome__container__text">
      <h1 class="welcome__container__text-title">iDepa</h1>

      <h2 class="welcome__container__text-subtitle">
        {{ "auth.subtitle" | translate }}
      </h2>

      <p
        class="welcome__container__text-description"
        [innerHTML]="'auth.description' | translate"
      ></p>

      <i-button
        [text]="'auth.connect' | translate"
        [styleClass]="'green mt-5'"
        [icon]="'bi bi-arrow-right-short'"
        (click)="login()"
      ></i-button>
    </div>
  </div>
</div>
